// Certification status per campaign (3 passed practice calls across >= 2 prospect types, once per niche; no expiry since 2026-10-01).
import type { CertificationRow } from '../../../src/shared/api-ai';
import { KIND_LABEL } from './labels';

export function certText(c: CertificationRow): string {
  if (c.exempt) return 'Exempt';
  if (c.certified) return 'Certified';
  const need = Math.max(0, c.required.sessions - c.passedSessions);
  const kinds = Math.max(0, c.required.kinds - c.personaKindsPassed.length);
  const parts: string[] = [];
  if (need) parts.push(`${need} more pass${need === 1 ? '' : 'es'}`);
  if (kinds) parts.push(`${kinds} more prospect type${kinds === 1 ? '' : 's'}`);
  return parts.length ? `Needs ${parts.join(' and ')}` : 'Not certified';
}

export function CertChip(props: { c: CertificationRow }) {
  const c = props.c;
  const cls = c.certified || c.exempt ? 'chip-ok' : 'chip-warn';
  const passedKinds = c.personaKindsPassed.map((k) => KIND_LABEL[k]).join(', ') || 'none';
  return (
    <span class={`chip ${cls}`} title={`${c.passedSessions} passed in this niche; types passed: ${passedKinds}`}>
      {c.campaignName}: {certText(c)}
    </span>
  );
}

export function Certs(props: { certs: CertificationRow[] }) {
  if (props.certs.length === 0) return <span class="muted" style="font-size:13px">You're not assigned to a campaign yet.</span>;
  return <div class="row" style="flex-wrap:wrap;gap:6px">{props.certs.map((c) => <CertChip c={c} />)}</div>;
}
